import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { freeholdConfig } from "./data";

export default function FreeholdPage() {
  return <CityPageTemplate config={freeholdConfig} />;
}